import {
  dispatchDispatchRequestAssocStatusTypes,
  DispatchRequestEntity,
  dispatchRequestStatus,
  DispatchRequestStatus
} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {Progress, ProgressProps} from "../Progress/Progress";
import {getDispatchRequestStatusColorRef} from "../../../util/dispatch-request-ui-util";

export const fromDispatchRequest = (dispatchRequest: DispatchRequestEntity): DispatchRequestProgressProps => {
  const totalJobs: number = dispatchRequest.dispatches.length;
  const completedJobs: number = dispatchRequest.dispatches.filter(
    (d) => d.status === dispatchDispatchRequestAssocStatusTypes.complete
  ).length;

  return {
    status: dispatchRequest.status,
    jobStatus: {
      completedJobs: completedJobs,
      totalJobs: totalJobs
    }
  }
}

export type DispatchRequestProgressProps = Omit<ProgressProps, 'color' | 'value' | 'label' | 'sections'> & {
  status: DispatchRequestStatus
  jobStatus?: {
    totalJobs: number
    completedJobs: number
  }
}

export const DispatchRequestProgress = (props: DispatchRequestProgressProps) => {
  const {status, jobStatus, ...rest} = props

  const color = useMemo(() => {
    return getDispatchRequestStatusColorRef(status)
  }, [status])

  const value = useMemo(() => {
    switch (status) {
      case dispatchRequestStatus.pending:
        return 10
      case dispatchRequestStatus.accepted:
        return 30
      case dispatchRequestStatus.started:
        return 45
      case dispatchRequestStatus.pickedUp:
        return 65
      case dispatchRequestStatus.pendingCancel:
      case dispatchRequestStatus.canceled:
      case dispatchRequestStatus.rejected:
      case dispatchRequestStatus.reassigned:
      case dispatchRequestStatus.completed:
      case dispatchRequestStatus.unresolved:
        return 100
      default:
        return 0
    }
  }, [status])

  return (<Progress {...rest} color={color} value={value}/>)
}
